import React from "react";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme) => ({
  root: {
    height: "100vh",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    background: "linear-gradient(45deg, #FE6B8B 30%, #FF8E53 90%)",
    backgroundSize: "400% 400%",
    animation: "$gradient 15s ease infinite",
  },
  "@keyframes gradient": {
    "0%": { backgroundPosition: "0% 50%" },
    "50%": { backgroundPosition: "100% 50%" },
    "100%": { backgroundPosition: "0% 50%" },
  },
  paper: {
    padding: theme.spacing(4),
    textAlign: "center",
  },
  icon: {
    fontSize: "4rem",
    marginBottom: theme.spacing(2),
  },
}));

const PreSetup = () => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <Paper className={classes.paper}>
        <ErrorOutlineIcon className={classes.icon} color="error" />
        <Typography variant="h5" component="h1">
          The site is not yet functional.
        </Typography>
        <Typography variant="body1">
          If you are the owner of the site, reach out to the tech team for more
          information. Come later and check.
        </Typography>
      </Paper>
    </div>
  );
};

export default PreSetup;
